import { object } from "yup";
export const a1Part1DataSchema = object({});
export const exampleA1Data = [
    {
        data: {},
    },
];
//# sourceMappingURL=a1.js.map